// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1pW80","errors":"Errors_errors__2AtkM"};